import { Product } from '../types/content';

export function formatMoney(value: number): string {
  return `$${value.toFixed(2)}`;
}

export function formatPriceRange(product: Product): string | null {
  if (product.options && product.options.length > 0) {
    const prices = product.options.map((o) => o.price);
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    return min === max ? formatMoney(min) : `${formatMoney(min)} – ${formatMoney(max)}`;
  }
  if (typeof product.price === 'number') return formatMoney(product.price);
  return null;
}
